module.exports = __webpack_public_path__ + "img/logo.f1621e56.png";